import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
var useModalState = function useModalState() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var showModal = function showModal() {
    return setShow(true);
  };
  var hideModal = function hideModal() {
    return setShow(false);
  };
  return {
    show: show,
    hideModal: hideModal,
    showModal: showModal
  };
};
export default useModalState;